import React, { Component } from "react";
import { Table } from "reactstrap";
import ServerPaginatedTable from "../../components/ServerPagination";
import { appHelpers } from "../../_helpers";
import moment from "moment";

export const WalletHistoryTable = ({ apiData }) => {
  return (
    <Table responsive striped hover>
      <thead className={"table-head-blue"}>
        <tr>
          <th style={{ padding: "none" }}>Invoice Id</th>
          <th style={{ padding: "none" }}>Amount</th>
          <th style={{ padding: "none" }}>Transaction type</th>
          <th style={{ padding: "none" }}>Date</th>
          <th style={{ padding: "none" }}>Status</th>
        </tr>
      </thead>
      <tbody>
        {apiData.map((item, index) => {
          return (
            <tr key={index} style={{ borderTop: "12px solid transparent" }}>
              <th>{item?.invoiceId}</th>
              <th>₦{appHelpers.numbersWithCommas(item?.amount)}</th>
              <th>{item.transactionType}</th>
              <th>{moment(item.date).format("DD MMM YY, h:mm A")}</th>
              <th>
                {
                  <span
                    className={`${
                      item?.status === "Successful"
                        ? "success-status"
                        : "failed-status"
                    }`}
                  >
                    {item?.status}
                  </span>
                }
              </th>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default class TableFormat extends Component {
  render() {
    let { apiData, currentPage, fetchMore, pageSize, totalCount, downloadDoc } = this.props;
    const pageIndex = currentPage === 0 ? 1 : pageSize * (currentPage - 1) + 1;
    return (
      <div>
        <ServerPaginatedTable
          currentPage={currentPage}
          fetchMore={fetchMore}
          pageSize={pageSize}
          totalCount={totalCount}
          positionBottomPagination={"left"}
          showBottomPagination
          topDownload={true}
          downloadExcel={() => {
            downloadDoc("excel");
          }}
          downloadPdf={() => {
            downloadDoc("pdf");
          }}
          target={
            <WalletHistoryTable apiData={apiData} pageIndex={pageIndex} />
          }
        />
      </div>
    );
  }
}
